module.exports = __webpack_public_path__ + "img/join_btn.6d12b349.png";